import { useQuery } from '@tanstack/react-query';
import { GetRegulatorHelpRequestsPayload, GetRegulatorHelpRequestsResponse } from '../types';
import { DASHBOARD_QUERY_KEYS } from '../query';
import DashboardService from '../service';

const useGetRegulatorHelpRequests = (params: GetRegulatorHelpRequestsPayload) => {
  const { data, isLoading, refetch } = useQuery<GetRegulatorHelpRequestsResponse>({
    queryKey: [DASHBOARD_QUERY_KEYS.GET_REGULATOR_HELP_REQUESTS, params],
    queryFn: () => DashboardService.getRegulatorHelpRequests(params),
    enabled: !!params.page && !!params.size && !!params.column && !!params.dir,
  });

  return { data: data?.data, isLoading, refetch };
};

export default useGetRegulatorHelpRequests;
